import api from "./api";

// Gọi tới backend Spring Boot hiện tại (/api/banners)
export const getBanners = async (params = {}) => {
    const response = await api.get("/api/banners", { params });
    return response.data;
};



